import { render } from "./GTComponent.vue?vue&type=template&id=5d8e2b6a&scoped=true"
import script from "./GTComponent.vue?vue&type=script&lang=js"
export * from "./GTComponent.vue?vue&type=script&lang=js"

import "./GTComponent.vue?vue&type=style&index=0&id=5d8e2b6a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5d8e2b6a"

export default script